import { createFileRoute } from "@tanstack/react-router";
import { SeriesCastPage } from "@/modules/SeriesDetails";

export const Route = createFileRoute("/_default/series/$series/cast")({
  component: SeriesCastPage,
});
